import InputAdornment from '@material-ui/core/InputAdornment'
import TextField from '@material-ui/core/TextField'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import ExpandableListElement from '../../components/controls/ExpandableListElement'
import LabelCheckbox from '../../components/controls/LabelCheckbox'
import Szambelan from '../../components/Szambelan'
import { controlHasError } from '../../lib/errorHandler'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'
import WykazJednostekSkonsolidowaneStyle from '../../styles/WykazJednostekSkonsolidowaneStyle'
import AnimateHeight from 'react-animate-height'
import logo from '../../assets/images/szambelan_jednostki_wylaczone.svg'
import PrintText from '../../lib/PrintText'

class WykazJednostekWylaczonych extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: -1,
      nazwyJednostek: props.section.Dane.Pozycje.map((x) =>
        x.NazwyJednostek ? true : false,
      ),
    }
  }

  handleNazwyJednostkiChange = (e, index) => {
    let x = [...this.state.nazwyJednostek]
    x[index] = e.target.checked
    this.setState({ nazwyJednostek: x })
  }

  handleToggleActive = (index) => {
    this.setState({ activeIndex: index })
  }

  handleAdd = (structure, sIndex) => {
    this.setState({
      nazwyJednostek: [...this.state.nazwyJednostek, false],
    })
    this.props.onAddDetailInfo(structure, sIndex)
  }

  render() {
    const {
      onSetSectionDataArray,
      section,
      validityErrors,
      czyPodsumowanie,
    } = this.props
    const struktura = {
      Nazwa: '',
      UzasadnienieWylaczenia: '',
      UdzialJednDominujacej: 0,
      NazwyJednostek: '',
    }
    return (
      <MainStyle
        className={section.Dane.Pozycje.length > 0 ? '' : 'hide-on-print'}
      >
        <WykazJednostekSkonsolidowaneStyle>
          <div className="site-header high-emphasis-subtitle-1">
            <span>
              WYKAZ JEDNOSTEK PODPORZĄDKOWANYCH WYŁĄCZONYCH ZE SKONSOLIDOWANEGO
              SPRAWOZDANIA FINANSOWEGO
            </span>
            <ButtonAddInfo
              label="DODAJ JEDNOSTKĘ"
              structure={struktura}
              handleAdd={this.handleAdd}
            />
          </div>
          {section.Dane.Pozycje.length > 0 ? (
            <div className="container">
              <div className="list-header caption">
                <p>
                  NAZWA I SIEDZIBA JEDNOSTKI PODPORZĄDKOWANEJ WYŁĄCZONEJ ZE
                  SKONSOLIDOWANEGO SPRAWOZDANIA FINANSOWEGO
                </p>
              </div>
              {section.Dane.Pozycje.map((data, index) => (
                <ExpandableListElement
                  placeholder="Nazwa i siedziba jednostki podporządkowanej wyłączonej ze skonsolidowanego sprawozdania finansowego"
                  nazwaPozycji={data.Nazwa}
                  isActive={this.state.activeIndex === index}
                  key={index}
                  index={index}
                  hasError={(name, value) =>
                    controlHasError(validityErrors, name, value, true)
                  }
                >
                  <div className="header">
                    <p>SZCZEGÓŁY</p>
                  </div>
                  <form autoComplete="off" className="subsection">
                    {czyPodsumowanie ? (
                      <PrintText
                        text={data.UzasadnienieWylaczenia}
                      />
                    ) : (
                      <TextField
                        className="textarea"
                        name="UzasadnienieWylaczenia"
                        multiline
                        variant="outlined"
                        label="Podstawa prawna oraz uzasadnienie dokonania wyłączenia"
                        value={data.UzasadnienieWylaczenia}
                        error={controlHasError(
                          validityErrors,
                          'UzasadnienieWylaczenia',
                          data.UzasadnienieWylaczenia,
                          true,
                        )}
                        onChange={(e) => onSetSectionDataArray(e, index)}
                        onFocus={() => this.handleToggleActive(index)}
                        onBlur={() => this.handleToggleActive(-1)}
                      />
                    )}
                    <div className="oneLine">
                      <span>
                        Udział jedn. dominującej, wspólnika jedn. współzależnej
                        lub znaczącego inwestora w kapitale (funduszu)
                        podstawowym:
                      </span>
                      <TextField
                        className="numericField"
                        placeholder="Udział"
                        name="UdzialJednDominujacej"
                        value={data.UdzialJednDominujacej}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">%</InputAdornment>
                          ),
                        }}
                        error={controlHasError(
                          validityErrors,
                          'UdzialJednDominujacej',
                          data.UdzialJednDominujacej,
                          true,
                        )}
                        onChange={(e) => onSetSectionDataArray(e, index)}
                      />
                    </div>
                    <div className="oneLine">
                      <LabelCheckbox
                        name="CzyDolaczycInformacje"
                        label="Dołącz informację o jednostkach podporządkowanych posiadających zaangażowanie w kapitale jednostki wyłączonej ze skonsolidowanego sprawozdania finansowego"
                        value={this.state.nazwyJednostek[index]}
                        change={(e) =>
                          this.handleNazwyJednostkiChange(e, index)
                        }
                      />
                    </div>
                    {!czyPodsumowanie ? (
                      <AnimateHeight
                        duration={250}
                        height={this.state.nazwyJednostek[index] ? 'auto' : 0}
                      >
                        <TextField
                          className="textarea"
                          name="NazwyJednostek"
                          multiline
                          variant="outlined"
                          label="Nazwy (firmy) i siedziby jednostek"
                          value={data.NazwyJednostek}
                          error={controlHasError(
                            validityErrors,
                            'NazwyJednostek',
                            data.NazwyJednostek,
                            true,
                          )}
                          onChange={(e) => onSetSectionDataArray(e, index)}
                          onFocus={() => this.handleToggleActive(index)}
                          onBlur={() => this.handleToggleActive(-1)}
                        />
                      </AnimateHeight>
                    ) : (
                      this.state.nazwyJednostek[index] && (
                        <PrintText
                          text={data.NazwyJednostek}
                        />
                      )
                    )}
                  </form>
                </ExpandableListElement>
              ))}
            </div>
          ) : (
            <Szambelan
              logo={logo}
              text={
                <>
                  Brak informacji o jednostkach <br /> podporządkowanych
                  <br /> wyłączonych ze skonsolidowanego
                  <br /> sprawozdania finansowego
                </>
              }
            />
          )}
        </WykazJednostekSkonsolidowaneStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors.filter(
          (value) => value.TypSekcji === 'WykazJednostekWylaczonych',
        )
      : [],
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionDataArray: (e, index) => {
      let { value, name } = e.target
      if (name === 'UdzialJednDominujacej') value = value.replace(',', '.')
      dispatch(actions.setSectionDataArray(value, index, 0, name))
    },
    onAddDetailInfo: (structure, sIndex) => {
      return dispatch(actions.addDetailInfo(structure, sIndex))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WykazJednostekWylaczonych)
